import { useState } from "react";
import { PodCreateRequest } from "../../../api/pods.types";
import CreatePodDialog from "../dialogs/CreatePodDialog";

const useCreatePodDialog = (handleSubmit: (data: PodCreateRequest, navigateOnSuccess: boolean) => void): [JSX.Element, Function, Function, Function, Function] => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorText, setErrorText] = useState('');

  const showDialog = () => {
    setLoading(false);
    setErrorText('');
    setVisible(true);
  };

  const hideDialog = () => {
    setVisible(false);
  };

  /**
   * Loading and erroring are mutually exclusive states,
   * so when we change one, we change the other.
   */
  const setIsLoading = (loading: boolean) => {
    setLoading(loading);
    setErrorText('');
  };

  const setError = (error: string) => {
    setLoading(false);
    setErrorText(error);
  };

  const dialogComponent = (
    <CreatePodDialog
      show={visible}
      loading={loading}
      error={errorText}
      onSubmit={handleSubmit}
      onDismiss={hideDialog}
    />
  );

  return [
    dialogComponent,
    showDialog,
    hideDialog,
    setIsLoading,
    setError,
  ];
};

export default useCreatePodDialog;